import { IconButton } from "@/components/Button/IconButton";
import { XCloseIcon } from "@/components/Icons/XCloseIcon";

export function MediaXButton(props: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  "data-testid"?: string;
  title: string;
}): React.ReactNode {
  return (
    <IconButton
      icon={<XCloseIcon size={12} />}
      variant="soft"
      tone="error"
      size="xs"
      isCircular
      withTooltip={false}
      type="button"
      {...props}
    />
  );
}
